import React from "react";

import { products } from "../ProductData";
import OrderSummery from "./OrderSummary";
import { useSelector } from "react-redux";
import CartItem from "./CartItem";

const Cart = () => {
  const { cartItems, cartQuantity } = useSelector((state) => state.cart);
  return (
    <>
      {cartQuantity === 0 ? (
        <div className=" min-h-screen  text-center text-xl mt-[30%]">
          No product added yeat
        </div>
      ) : (
        <div className="px-[10px] md:px-[20px] min-h-screen lg:px-[10%] pt-10">
          <div className=" flex flex-row flex-wrap justify-center   ">
            <div className="flex-1 bg-white rounded  p-2">
              <div className=" flex justify-between text-xl font-semibold border-b pb-5 mb-5 ">
                <h3>Shopping Cart</h3>
                <h3>
                  {cartItems?.length} <span>Items</span>
                </h3>
              </div>
              <div>
                {cartItems.map((item) => (
                  <CartItem
                    key={item.id + "2"}
                    name={item.name}
                    id={item.id}
                    price={item.price}
                    image={item.image}
                    quantity={item.quantity}
                  />
                ))}
              </div>
            </div>
            <div>
              <OrderSummery />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Cart;
